// PUBLIC (www) entry: Turbo, Stimulus and only the controllers the marketing
// pages mount. APP keeps application.js and its full manifest.
import "@hotwired/turbo-rails"
import { application } from "./controllers/application"

import Chart__BasicController from "./controllers/chart/basic_controller"
application.register("chart--basic", Chart__BasicController)

import Chart__Guage__MoiController from "./controllers/chart/guage/moi_controller"
application.register("chart--guage--moi", Chart__Guage__MoiController)

import Chart__Line__InterestRatesController from "./controllers/chart/line/interest_rates_controller"
application.register("chart--line--interest-rates", Chart__Line__InterestRatesController)

import Chart__Line__JobGrowthController from "./controllers/chart/line/job_growth_controller"
application.register("chart--line--job-growth", Chart__Line__JobGrowthController)

import Map__LeafletBasicController from "./controllers/map/leaflet_basic_controller"
application.register("map--leaflet-basic", Map__LeafletBasicController)

import Public__AccordionController from "./controllers/public/accordion_controller"
application.register("public--accordion", Public__AccordionController)

import Public__BillingController from "./controllers/public/billing_controller"
application.register("public--billing", Public__BillingController)

import CountUpController from "./controllers/count_up_controller"
application.register("count-up", CountUpController)

import Public__HeroLoopController from "./controllers/public/hero_loop_controller"
application.register("public--hero-loop", Public__HeroLoopController)

import Public__HeroSearchController from "./controllers/public/hero_search_controller"
application.register("public--hero-search", Public__HeroSearchController)

import Public__LearnSearchController from "./controllers/public/learn_search_controller"
application.register("public--learn-search", Public__LearnSearchController)

import Public__NavController from "./controllers/public/nav_controller"
application.register("public--nav", Public__NavController)

import Public__ReportAssemblyController from "./controllers/public/report_assembly_controller"
application.register("public--report-assembly", Public__ReportAssemblyController)

import Public__TerritoryTourController from "./controllers/public/territory_tour_controller"
application.register("public--territory-tour", Public__TerritoryTourController)

import Public__RebrandController from "./controllers/public/rebrand_controller"
application.register("public--rebrand", Public__RebrandController)

import Public__LoopVideoController from "./controllers/public/loop_video_controller"
application.register("public--loop-video", Public__LoopVideoController)

import Public__SoundController from "./controllers/public/sound_controller"
application.register("public--sound", Public__SoundController)

// The full snapshot's month and comparison selectors are the app's dropdowns.
import Ui__DropdownController from "./controllers/ui/dropdown_controller"
application.register("ui--dropdown", Ui__DropdownController)

// The full snapshot's chart headings explain themselves through this tooltip.
import Ui__TooltipController from "./controllers/ui/tooltip_controller"
application.register("ui--tooltip", Ui__TooltipController)

import Vendor__AhoyController from "./controllers/vendor/ahoy_controller"
application.register("vendor--ahoy", Vendor__AhoyController)

import Vendor__BeaconController from "./controllers/vendor/beacon_controller"
application.register("vendor--beacon", Vendor__BeaconController)

import ahoy from "ahoy.js"
ahoy.configure({ cookieDomain: document.querySelector('meta[name="ahoy-cookie-domain"]').content })
window.ahoy = ahoy

import './vendor/posthog'

import Public__AssistantVideoController from "./controllers/public/assistant_video_controller"
application.register("public--assistant-video", Public__AssistantVideoController)

import Public__CopyValueController from "./controllers/public/copy_value_controller"
application.register("public--copy-value", Public__CopyValueController)

// A partner media kit zips a post's slides and caption the way the app's Social page does.
import DownloadController from "./controllers/download_controller"
application.register("download", DownloadController)

import Vendor__PosthogController from "./controllers/vendor/posthog_controller"
application.register("vendor--posthog", Vendor__PosthogController)

import Public__SectionViewedController from "./controllers/public/section_viewed_controller"
application.register("public--section-viewed", Public__SectionViewedController)
